export default __webpack_public_path__ + "static/media/like.28a18313.svg";